export default __webpack_public_path__ + "img/documentation.e889cedc.png";